import * as THREE from 'three';

import Stats from 'three/examples/jsm/libs/stats.module.js';
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';


import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader.js';
import { RGBMLoader } from 'three/examples/jsm/loaders/RGBMLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';
import { RoughnessMipmapper } from 'three/examples/jsm/utils/RoughnessMipmapper.js';

import { MeshStandardNodeMaterial } from 'three/examples/jsm/nodes/Nodes.js';

import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


/*
Kafa Zoom
Camera PX = -2.2
Camera PY = 10.9
Camera PZ = 8.4

Kol Zoom
Camera PX = -2.5
Camera PY = 7.5
Camera PZ = 13.9

Ayak Zoom
Camera PX = -0.4
Camera PY = 1.3
Camera PZ = 9.6
Camera RX = 0.06

*/


import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

let camera, scene, container, stats;
let renderer;
let transition;
let mixer, mixer1;
let model;
let loader;
let controls;

let lumiereS, sphereTab = []

let animationStep = {
    frame: 0
};
const gui = new dat.GUI();

if (window.location.search !== "?debug") {
    document.querySelector(".lil-gui").remove()
}

const debugParameters = {
    modelScale: 1,
    mixerDuration: 0.7,
    mixerSetTime: 0,
    fogNear: 0.1,
    fog: 0,
    circleColor1: 0x324057,
    circleColor2: 0x060d19,
    dirLightColor: 0x7088ff,
    modeColor: 0x545454,
    modeColorZemin: 0x787878,
}
let pmremGenerator;
const clock = new THREE.Clock();

if (window.innerWidth >= 1200) {
    if ($("#human-model").length) {
        init();
    }
} else {
    $("body").removeClass("overflow")
}

if (!$("#human-model").length) {
    $(".pre-loader").css("display", "none")
    setTimeout(() => {
        $("body").removeClass("overflow")
    }, 1500);
}

$(".info-pagination > .pagi-item").click(function () {
    let itemIndex = $(this).index() + 1

    // $(this).addClass("active")
    // $(this).prevAll(".pagi-item").addClass("active")
    // $(this).nextAll(".pagi-item").removeClass("active")

    // $(this).prevAll(".pagi-line").addClass("active")
    // $(this).nextAll(".pagi-line").removeClass("active")

    if (itemIndex === 1) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 1290 })
    }

    if (itemIndex === 3) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 2690 })
    }

    if (itemIndex === 5) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 4090 })
    }

    if (itemIndex === 7) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 5490 })
    }

    if (itemIndex === 9) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 6490 })
    }

    if (itemIndex === 11) {
        gsap.to(window, { duration: 0.6, scrollTo: window.innerHeight + 7490 })
    }
});

function marqueeItem(item, reverse, duration) {
    const dur = duration;
    let ticker = document.querySelector(item)

    let totalDistance;
    $(item).append($(item).children("span").clone());
    let anim;

    function resize() {
        if (anim) anim.play(0);
        totalDistance = $(ticker).width() / 2;

        anim = gsap.to($(item).children("span"), {
            duration: dur,
            x: reverse ? totalDistance : -totalDistance,
            ease: "none",
            repeat: -1,
            overwrite: true
        });
    }

    $(window).resize(resize);
    resize();
}

marqueeItem(".model-title-container .title-item:nth-child(1) .item-wrapper", false, 10)
marqueeItem(".model-title-container .title-item:nth-child(2) .item-wrapper", false, 10)
marqueeItem(".model-title-container .title-item:nth-child(3) .item-wrapper", false, 10)
marqueeItem(".model-title-container .title-item:nth-child(4) .item-wrapper", false, 10)
marqueeItem(".model-title-container .title-item:nth-child(5) .item-wrapper", false, 10)

function scrollAnimation(model, camera) {
    gsap.to(window, { duration: 0.1, ease: "none", scrollTo: 0 })

    setTimeout(() => {
        gsap.to(".pre-loader", {
            autoAlpha: 0,
            duration: 0.5,
            ease: "circ.inOut",
        })

        gsap.to(".pre-loader .loader-container", {
            scale: 0,
            duration: 1,
            ease: "circ.inOut",
        })
    }, 3000);

    setTimeout(() => {
        gsap.to(camera.position, {
            x: 8,
            y: -0.9,
            z: 2.4,
            ease: "none",
            duration: 0.1,
        })

        gsap.to(camera.rotation, {
            x: 0,
            y: -0.3,
            z: 0,
            ease: "none",
            duration: 0.1,
        })

        gsap.to(".model-title-container", {
            opacity: 0,
            duration: 0.1,
        })

        gsap.to(".model-title-container .title-item:nth-child(1)", { autoAlpha: 1, duration: 0.1, })
        gsap.to(".model-title-container .title-item:nth-child(2)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-title-container .title-item:nth-child(3)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-title-container .title-item:nth-child(4)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-title-container .title-item:nth-child(5)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-title-container .title-item:nth-child(6)", { autoAlpha: 0, duration: 0.1, })

        gsap.to(".model-info-container .info-item:nth-child(1)", { autoAlpha: 1, duration: 0.1, })
        gsap.to(".model-info-container .info-item:nth-child(2)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-info-container .info-item:nth-child(3)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-info-container .info-item:nth-child(4)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-info-container .info-item:nth-child(5)", { autoAlpha: 0, duration: 0.1, })
        gsap.to(".model-info-container .info-item:nth-child(6)", { autoAlpha: 0, duration: 0.1, })

        model.children.forEach(function (item) {
            // Head [6]
            if (item.name === "bas") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = -0.006
                item.children[0].position.y = -0.11
                item.children[0].position.z = 0.136
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.z = 0.155
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }

            // Hand [3]
            if (item.name === "hand") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = -0.02
                item.children[0].position.y = 0.758
                item.children[0].position.z = -0.156
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.x = -0.014
                item.children[1].position.y = 0.757
                item.children[1].position.z = -0.18
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }

            // Heart [4]
            if (item.name === "kalp") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = 0.147
                item.children[0].position.y = 0.342
                item.children[0].position.z = 0.417
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.z = 0.435
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }

            // Arm [5]
            if (item.name === "kol") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = 0
                item.children[0].position.y = 0.011
                item.children[0].position.z = -0.149
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.z = -0.171
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }

            // Spine [2]
            if (item.name === "omirilik") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = -0.021
                item.children[0].position.y = 0.177
                item.children[0].position.z = -0.216
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.z = -0.24
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }

            // Foot [3]
            if (item.name === "ayak") {
                item.scale.set(0, 0, 0)
                item.children[0].position.x = 0
                item.children[0].position.y = 0.034
                item.children[0].position.z = 0.176
                item.children[1].scale.set(0.25, 0.25, 0.25);
                item.children[1].position.z = 0.203
                item.children[0].material.color = new THREE.Color(debugParameters.circleColor1);
                item.children[1].material.color = new THREE.Color(debugParameters.circleColor2);
            }
        });

        const modelCircleFolder = gui.addFolder('Model Circle')
        modelCircleFolder.add(model.children[2].children[0].position, 'x').min(-1).max(1).step(0.001).name("px");
        modelCircleFolder.add(model.children[2].children[0].position, 'y').min(-1).max(1).step(0.001).name("py");
        modelCircleFolder.add(model.children[2].children[0].position, 'z').min(-1).max(1).step(0.001).name("pz");
        modelCircleFolder.add(model.children[2].children[1].position, 'x').min(-1).max(1).step(0.001).name("cz");
        modelCircleFolder.add(model.children[2].children[1].position, 'y').min(-1).max(1).step(0.001).name("cz");
        modelCircleFolder.add(model.children[2].children[1].position, 'z').min(-1).max(1).step(0.001).name("cz");
        // modelCircleFolder.addColor(debugParameters, 'circleColor1').onChange(() => {
        //     model.children[4].children[0].material.color = new THREE.Color(debugParameters.circleColor1)
        // })
        // modelCircleFolder.addColor(debugParameters, 'circleColor2').onChange(() => {
        //     model.children[4].children[1].material.color = new THREE.Color(debugParameters.circleColor2)
        // })
        modelCircleFolder.open()
    }, 500);

    setTimeout(() => {
        // gsap.to(camera.position, {
        //     x: 8,
        //     delay: 1,
        //     duration: 1.5,
        // })

        setTimeout(() => {
            $("body").removeClass("overflow")
        }, 3000);
    }, 1000);

    if (model) {
        gsap.to(".hero-section .hero-gradient", {
            xPercent: -20,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1,
            }
        })

        //--

        gsap.fromTo(debugParameters, {
            mixerDuration: debugParameters.mixerDuration,
        }, {
            mixerDuration: 0.1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1.1,
            }
        })

        // Hand Zoom
        gsap.fromTo(camera.position, {
            x: 8,
            y: -0.9,
            z: 2.4,
        }, {
            x: 9,
            y: -1.6,
            z: 3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: -0.3,
        }, {
            y: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1.1,
            }
        })

        // Arm Zoom
        gsap.fromTo(camera.position, {
            x: 9,
            y: -1.6,
            z: 3,
        }, {
            x: 10.1,
            y: -1.1,
            z: 3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 1300) + "px top",
                end: "top+=" + (window.innerHeight + 2300) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 0,
        }, {
            y: 0.4,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 1300) + "px top",
                end: "top+=" + (window.innerHeight + 2300) + "px top",
                scrub: 1.1,
            }
        })

        // Spine Zoom
        gsap.fromTo(camera.position, {
            x: 10.1,
            y: -1.1,
            z: 3,
        }, {
            x: 11.7,
            y: -1.2,
            z: -0.5,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 2700) + "px top",
                end: "top+=" + (window.innerHeight + 3700) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 0.4,
        }, {
            y: 2.18,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 2700) + "px top",
                end: "top+=" + (window.innerHeight + 3700) + "px top",
                scrub: 1.1,
            }
        })

        // Foot Zoom
        gsap.fromTo(camera.position, {
            x: 11.7,
            y: -1.2,
            z: -0.5,
        }, {
            x: 7.8,
            y: -2.7,
            z: 1.1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 4100) + "px top",
                end: "top+=" + (window.innerHeight + 5100) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 2.18,
        }, {
            y: -0.75,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 4100) + "px top",
                end: "top+=" + (window.innerHeight + 5100) + "px top",
                scrub: 1.1,
            }
        })

        // Heart
        gsap.fromTo(camera.position, {
            x: 7.8,
            y: -2.7,
            z: 1.1,
        }, {
            x: 8.5,
            y: -1,
            z: 1.1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 5500) + "px top",
                end: "top+=" + (window.innerHeight + 6500) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: -0.75,
        }, {
            y: -0.6,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 5500) + "px top",
                end: "top+=" + (window.innerHeight + 6500) + "px top",
                scrub: 1.1,
            }
        })

        // Head Zoom
        gsap.fromTo(camera.position, {
            x: 8.5,
            y: -1,
            z: 1.1,
        }, {
            x: 8,
            y: -0.3,
            z: 1.3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 6900) + "px top",
                end: "top+=" + (window.innerHeight + 7900) + "px top",
                scrub: 1.1,
            }
        })

        // Head Zoom
        // gsap.fromTo(camera.position, {
        //     x: 8,
        //     y: -0.9,
        //     z: 2.4,
        // }, {
        //     x: 8,
        //     y: -0.3,
        //     z: 1.3,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + window.innerHeight + "px bottom",
        //         end: "top+=" + window.innerHeight + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // gsap.fromTo(camera.rotation, {
        //     y: -0.3,
        // }, {
        //     y: -0.6,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + window.innerHeight + "px bottom",
        //         end: "top+=" + window.innerHeight + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // Heart Zoom
        // gsap.fromTo(camera.position, {
        //     x: 8,
        //     y: -0.3,
        //     z: 1.3,
        // }, {
        //     x: 8.5,
        //     y: -1,
        //     z: 1.1,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 1300) + "px top",
        //         end: "top+=" + (window.innerHeight + 2300) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // Arm Zoom
        // gsap.fromTo(camera.position, {
        //     x: 8.5,
        //     y: -1,
        //     z: 1.1,
        // }, {
        //     x: 10.4,
        //     y: -0.3,
        //     z: 3,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 2700) + "px top",
        //         end: "top+=" + (window.innerHeight + 3700) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // gsap.fromTo(camera.rotation, {
        //     x: 0,
        //     y: -0.6,
        // }, {
        //     x: -0.4,
        //     y: 0.45,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 2700) + "px top",
        //         end: "top+=" + (window.innerHeight + 3700) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // Spine Zoom
        // gsap.fromTo(camera.position, {
        //     x: 10.4,
        //     y: -0.3,
        //     z: 3,
        // }, {
        //     x: 11.7,
        //     y: -1.2,
        //     z: -0.5,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 4100) + "px top",
        //         end: "top+=" + (window.innerHeight + 5100) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // gsap.fromTo(camera.rotation, {
        //     x: -0.4,
        //     y: 0.45,
        // }, {
        //     x: 0,
        //     y: 2.18,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 4100) + "px top",
        //         end: "top+=" + (window.innerHeight + 5100) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // Foot Zoom
        // gsap.fromTo(camera.position, {
        //     x: 11.7,
        //     y: -1.2,
        //     z: -0.5,
        // }, {
        //     x: 7.8,
        //     y: -2.7,
        //     z: 1.1,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 5500) + "px top",
        //         end: "top+=" + (window.innerHeight + 6500) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // gsap.fromTo(camera.rotation, {
        //     y: 2.18,
        // }, {
        //     y: -0.75,

        //     scrollTrigger: {
        //         trigger: "body",
        //         start: "top+=" + (window.innerHeight + 5500) + "px top",
        //         end: "top+=" + (window.innerHeight + 6500) + "px top",
        //         scrub: 1.1,
        //     }
        // })

        // Wrapper
        gsap.to(".model-title-container", {
            opacity: 1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight) + "px top",
                end: "top+=" + (window.innerHeight + 500) + "px top",
                scrub: 1,
            }
        })

        //--

        setTimeout(() => {
            gsap.to(".model-info-container", {
                autoAlpha: 0,
                yPercent: 10,
                ease: "none",
                duration: 0.1,
            })
        }, 100);

        gsap.fromTo(".model-info-container", {
            autoAlpha: 0,
            yPercent: 10,
        }, {
            autoAlpha: 1,
            yPercent: -20,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight) + "px top",
                end: "top+=" + (window.innerHeight + 500) + "px top",
                scrub: 1,
            }
        })

        // Heart Zoom Text
        gsap.to(".model-info-container .info-item:nth-child(1)", {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-info-container .info-item:nth-child(2)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
        })

        //-

        gsap.fromTo(".model-title-container .title-item:nth-child(1)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-title-container .title-item:nth-child(2)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
        })

        // Arm Zoom Text
        gsap.fromTo(".model-info-container .info-item:nth-child(2)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-info-container .info-item:nth-child(3)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
        })

        //-

        gsap.fromTo(".model-title-container .title-item:nth-child(2)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-title-container .title-item:nth-child(3)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
        })

        // Spine Zoom Text
        gsap.fromTo(".model-info-container .info-item:nth-child(3)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-info-container .info-item:nth-child(4)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
        })

        //-

        gsap.fromTo(".model-title-container .title-item:nth-child(3)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-title-container .title-item:nth-child(4)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
        })

        // Foot Zoom Text
        gsap.fromTo(".model-info-container .info-item:nth-child(4)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-info-container .info-item:nth-child(5)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
        })

        //-

        gsap.fromTo(".model-title-container .title-item:nth-child(4)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-title-container .title-item:nth-child(5)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
        })

        // Head Zoom Text
        gsap.fromTo(".model-info-container .info-item:nth-child(5)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-info-container .info-item:nth-child(6)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
        })

        //-

        gsap.fromTo(".model-title-container .title-item:nth-child(5)", {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
        })

        gsap.fromTo(".model-title-container .title-item:nth-child(6)", {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
        })

        // Pagination Class
        // Hand
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight) + "px top",
            end: "top+=" + (window.innerHeight) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-item:nth-child(1)").addClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line").removeClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-item:nth-child(1)").removeClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line").removeClass("active")
            },
        });

        // Arm
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight + 1300) + "px top",
            end: "top+=" + (window.innerHeight + 1300) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-line:nth-child(2)").addClass("active")

                $(".info-pagination > .pagi-item:nth-child(3)").addClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(4)").addClass("active").nextAll(".pagi-line").removeClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-line:nth-child(2)").removeClass("active")

                $(".info-pagination > .pagi-item:nth-child(3)").removeClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(4)").removeClass("active").nextAll(".pagi-line").removeClass("active")
            },
        });

        // Spine
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight + 2700) + "px top",
            end: "top+=" + (window.innerHeight + 2700) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-item:nth-child(5)").addClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(6)").addClass("active").nextAll(".pagi-line").removeClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-item:nth-child(5)").removeClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(6)").removeClass("active").nextAll(".pagi-line").removeClass("active")
            },
        });

        // Foot
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight + 4100) + "px top",
            end: "top+=" + (window.innerHeight + 4100) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-item:nth-child(7)").addClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(8)").addClass("active").nextAll(".pagi-line").removeClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-item:nth-child(7)").removeClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(8)").removeClass("active").nextAll(".pagi-line").removeClass("active")
            },
        });

        // Heart
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight + 5500) + "px top",
            end: "top+=" + (window.innerHeight + 5500) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-item:nth-child(9)").addClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(10)").addClass("active").nextAll(".pagi-line").removeClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-item:nth-child(9)").removeClass("active").nextAll(".pagi-item").removeClass("active")
                $(".info-pagination > .pagi-line:nth-child(10)").removeClass("active").nextAll(".pagi-line").removeClass("active")
            },
        });

        // Head
        ScrollTrigger.create({
            trigger: "body",
            start: "top+=" + (window.innerHeight + 6900) + "px top",
            end: "top+=" + (window.innerHeight + 6900) + "px top",
            onEnter: () => {
                $(".info-pagination > .pagi-item:nth-child(11)").addClass("active")
            },
            onEnterBack: () => {
                $(".info-pagination > .pagi-item:nth-child(11)").removeClass("active")
            },
        });

        // Final
        gsap.to("#human-model-plane > canvas", {
            autoAlpha: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1.1,
            }
        })

        gsap.to("#human-model > canvas", {
            autoAlpha: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1.1,
            }
        })

        gsap.to(".item-wrapper", {
            opacity: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        gsap.to(".model-info", {
            autoAlpha: 0,
            yPercent: -50,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        gsap.fromTo(".model-info-container", {
            pointerEvents: "all",
        }, {
            pointerEvents: "none",

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        gsap.to(".hero-gradient", {
            opacity: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        gsap.to(".hero-color-gradient", {
            opacity: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        gsap.to(".model-fog", {
            opacity: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 8400) + "px top",
                end: "top+=" + (window.innerHeight + 9400) + "px top",
                scrub: 1,
            }
        })

        //--


        const modelColorFolder = gui.addFolder('Model Color')

        model.children.forEach(function (item) {
            // human_model
            // human_model001

            if (item.name === "human_model001") {
                modelColorFolder.addColor(debugParameters, 'modeColor').onChange(() => {
                    item.material.color = new THREE.Color(debugParameters.modeColor)
                })
            }

            if (item.name === "zemin") {
                modelColorFolder.addColor(debugParameters, 'modeColorZemin').onChange(() => {
                    item.material.color = new THREE.Color(debugParameters.modeColorZemin)
                })
            }

            // Hand [4]
            if (item.name === "hand") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + window.innerHeight + "px bottom", end: "top+=" + window.innerHeight + "px top", scrub: 1.1, }
                })

                gsap.fromTo(item.scale, {
                    x: 1,
                    y: 1,
                    z: 1,
                }, {
                    x: 0,
                    y: 0,
                    z: 0,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
                })
            }

            // Arm [5]
            if (item.name === "kol") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 1300) + "px top", end: "top+=" + (window.innerHeight + 1800) + "px top", scrub: 1.1, }
                })

                gsap.fromTo(item.scale, {
                    x: 1,
                    y: 1,
                    z: 1,
                }, {
                    x: 0,
                    y: 0,
                    z: 0,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
                })
            }

            // Spine [2]
            if (item.name === "omirilik") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 2700) + "px top", end: "top+=" + (window.innerHeight + 3200) + "px top", scrub: 1.1, }
                })

                gsap.fromTo(item.scale, {
                    x: 1,
                    y: 1,
                    z: 1,
                }, {
                    x: 0,
                    y: 0,
                    z: 0,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
                })
            }

            // Foot [3]
            if (item.name === "ayak") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 4100) + "px top", end: "top+=" + (window.innerHeight + 4600) + "px top", scrub: 1.1, }
                })

                gsap.fromTo(item.scale, {
                    x: 1,
                    y: 1,
                    z: 1,
                }, {
                    x: 0,
                    y: 0,
                    z: 0,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
                })
            }

            // Heart [4]
            if (item.name === "kalp") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 5500) + "px top", end: "top+=" + (window.innerHeight + 6000) + "px top", scrub: 1.1, }
                })

                gsap.fromTo(item.scale, {
                    x: 1,
                    y: 1,
                    z: 1,
                }, {
                    x: 0,
                    y: 0,
                    z: 0,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
                })
            }

            // Head [6]
            if (item.name === "bas") {
                gsap.fromTo(item.children[0].scale, { x: 0, y: 0, z: 0, }, { x: 1.3, y: 1.3, z: 1.3, duration: 2, stagger: { repeat: -1 } });
                gsap.to(item.children[0].material, { opacity: 0, duration: 2, stagger: { repeat: -1 } });
                gsap.fromTo(item.children[1].scale, { x: 0.25, y: 0.25, z: 0.25, }, { x: 0.3, y: 0.3, z: 0.3, duration: 1, ease: "Back.easeInOut", stagger: { repeat: -1, yoyo: true } });

                gsap.fromTo(item.scale, {
                    x: 0,
                    y: 0,
                    z: 0,
                }, {
                    x: 1,
                    y: 1,
                    z: 1,
                    scrollTrigger: { trigger: "body", start: "top+=" + (window.innerHeight + 6900) + "px top", end: "top+=" + (window.innerHeight + 7400) + "px top", scrub: 1.1, }
                })
            }
        });

        //--

        const modelFolder = gui.addFolder('Model')
        modelFolder.add(model.position, 'x').min(-500).max(2000).step(0.1).name("px");
        modelFolder.add(model.position, 'y').min(-500).max(2000).step(0.1).name("py");
        modelFolder.add(model.position, 'z').min(-500).max(4000).step(0.1).name("pz");
        modelFolder.add(model.rotation, 'x').min(-10).max(10).step(0.001).name("rx");
        modelFolder.add(model.rotation, 'y').min(-10).max(10).step(0.001).name("ry");
        modelFolder.add(model.rotation, 'z').min(-10).max(10).step(0.001).name("rz");
        modelFolder.add(debugParameters, 'modelScale').min(0).max(10).step(0.1).name("scale").onChange(() => {
            model.scale.set(debugParameters.modelScale, debugParameters.modelScale, debugParameters.modelScale)
        });
        modelFolder.open()
    }
}

function init() {

    const container = document.getElementById('human-model');
    camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.2, 2000);

    scene = new THREE.Scene();
    // scene.fog = new THREE.Fog(0xf6fafc, debugParameters.fogNear, debugParameters.fog);

    // #17256F
    // #f8a0a1
    let dirLight = new THREE.DirectionalLight(debugParameters.dirLightColor, 1, 100);
    dirLight.position.set(-212, 33, -500); //default; light shining from top
    dirLight.intensity = 3;
    dirLight.castShadow = true;
    scene.add(dirLight);

    // dirLight.shadow.mapSize.width = 1024; // default
    // dirLight.shadow.mapSize.height = 1024; // default



    lumiereS = new THREE.MeshBasicMaterial({
        color: 0x17256f,
    });

    let lumiereS2 = new THREE.MeshBasicMaterial({
        color: 0xfea0a1,
    });

    for (var i = 0; i < 600; i++) {
        sphereTab.push(new THREE.Mesh(new THREE.OctahedronGeometry(Math.random() * 0.5, 6), lumiereS));
    }

    for (var i = 0; i < 600; i++) {
        sphereTab.push(new THREE.Mesh(new THREE.OctahedronGeometry(Math.random() * 0.5, 6), lumiereS2));
    }

    for (var i = 0; i < sphereTab.length; i++) {
        sphereTab[i].position.set(Math.random() * 500 + 500, Math.random() * 50, Math.random() * 500 + 500);
        scene.add(sphereTab[i]);
    }

    const fogFolder = gui.addFolder('Fog')
    fogFolder.add(debugParameters, 'fogNear').min(0).max(10).step(0.001).name("Fog Near").onChange(() => {
        scene.fog = new THREE.Fog(0xf6fafc, debugParameters.fogNear, debugParameters.fog);
    });
    fogFolder.add(debugParameters, 'fog').min(0).max(100).step(0.001).name("Fog").onChange(() => {
        scene.fog = new THREE.Fog(0xf6fafc, debugParameters.fogNear, debugParameters.fog);
    });
    fogFolder.open()

    const cameraFolder = gui.addFolder('Camera')
    cameraFolder.add(camera.position, 'x').min(-500).max(2000).step(0.1).name("px");
    cameraFolder.add(camera.position, 'y').min(-500).max(2000).step(0.1).name("py");
    cameraFolder.add(camera.position, 'z').min(-500).max(4000).step(0.1).name("pz");
    cameraFolder.add(camera.rotation, 'x').min(-10).max(10).step(0.001).name("rx");
    cameraFolder.add(camera.rotation, 'y').min(-10).max(10).step(0.001).name("ry");
    cameraFolder.add(camera.rotation, 'z').min(-10).max(10).step(0.001).name("rz");
    cameraFolder.open()

    const dirLightFolder = gui.addFolder('dirLight')
    dirLightFolder.add(dirLight.position, 'x').min(-500).max(2000).step(0.1).name("px");
    dirLightFolder.add(dirLight.position, 'y').min(-500).max(2000).step(0.1).name("py");
    dirLightFolder.add(dirLight.position, 'z').min(-500).max(4000).step(0.1).name("pz");
    dirLightFolder.addColor(debugParameters, 'dirLightColor').onChange(() => {
        dirLight.color = new THREE.Color(debugParameters.dirLightColor);
    });
    dirLightFolder.add(dirLight.shadow.camera, 'near').min(-500).max(4000).step(0.1).name("shadow near");
    dirLightFolder.add(dirLight.shadow.camera, 'far').min(-500).max(4000).step(0.1).name("shadow far");
    dirLightFolder.add(dirLight, 'intensity').min(-500).max(4000).step(0.1).name("intensity");
    dirLightFolder.open()

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0xffffff, 0);
    renderer.outputEncoding = THREE.sRGBEncoding;

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 2;

    pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    container.appendChild(renderer.domElement);

    new THREE.TextureLoader()
        .load('./assets/img/environment.jpeg', function (texture) {

            const envMap = pmremGenerator.fromEquirectangular(texture).texture;

            // scene.background = envMap;
            scene.environment = envMap;

            texture.dispose();
            pmremGenerator.dispose();

            // use of RoughnessMipmapper is optional
            const roughnessMipmapper = new RoughnessMipmapper(renderer);

            // .setPath('./assets/img/')
            // loader = new GLTFLoader().setPath('./');
            loader = new GLTFLoader().load('./assets/model/model.glb', function (gltf) {
                model = gltf.scene.children[0]

                gltf.scene.position.set(10, -4, 0)
                gltf.scene.scale.set(1, 1, 1)
                gltf.scene.rotation.set(0, -1.2, 0)

                mixer = new THREE.AnimationMixer(gltf.scene);
                gltf.animations.forEach((clip) => {
                    mixer.clipAction(clip).play();
                });

                gltf.scene.traverse(function (child) {
                    child.castShadow = true;
                    // child.receiveShadow = true;

                    if (child.isMesh) {
                        // console.log(child);

                        child.material.transparent = true;
                        child.material.color = new THREE.Color(0xffffff);

                        roughnessMipmapper.generateMipmaps(child.material);
                    }
                });

                // console.log(gltf.scene.children[6].children[0]);

                if (model) {
                    scrollAnimation(model, camera)
                }

                // console.log(model);

                scene.add(gltf.scene);

                roughnessMipmapper.dispose();

                animate()
            });
        });

    // Camera Position
    camera.position.set(8, -0.9, 2.4);
    camera.rotation.set(0, -0.3, 0);
    scene.add(camera);

    // const helper = new THREE.CameraHelper(dirLight.shadow.camera);
    // scene.add(helper);

    window.addEventListener('resize', onWindowResize);

    // controls = new OrbitControls(camera, renderer.domElement);
    // controls.target.set(0, 0.5, 0);
}

function onWindowResize() {

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}

function animate() {
    requestAnimationFrame(animate);

    let delta = clock.getDelta();

    if (mixer) {
        mixer.update(delta * debugParameters.mixerDuration);
    }

    var timer = 0.0001 * Date.now();
    for (var i = 0; i < sphereTab.length; i++) {
        var sfere = sphereTab[i];
        sfere.position.x = (300 * Math.sin(timer + i));
        sfere.position.z = (500 * Math.sin(timer + i * 1.1)) + 300;
    }


    // controls.update();

    renderer.render(scene, camera);

}